// extracted by mini-css-extract-plugin
module.exports = {"sideNav":"sideNav-module--sideNav--1JwpI","active":"sideNav-module--active--XtP42"};